import { mapState } from 'vuex'
export default {
  computed: mapState({
    callStatus: (state) => state.callStatus,
  }),
  async created() {
    // 添加事件监听
    this.initListener()
  },
  destroyed() {
    this.removeListener()
  },
  methods: {
    initListener() {
      // sdk内部发生了错误
      this.$tuiCallEngine.on(this.TUICallEvent.ERROR, this.handleError)
      // 被邀请进行通话
      this.$tuiCallEngine.on(
        this.TUICallEvent.INVITED,
        this.handleNewInvitationReceived,
      )
      // 如果有用户接听，那么会收到此回调
      this.$tuiCallEngine.on(
        this.TUICallEvent.USER_ACCEPT,
        this.handleUserAccept,
      )
      // 如果有用户同意进入通话，那么会收到此回调
      this.$tuiCallEngine.on(this.TUICallEvent.USER_ENTER, this.handleUserEnter)
      // 如果有用户同意离开通话，那么会收到此回调
      this.$tuiCallEngine.on(this.TUICallEvent.USER_LEAVE, this.handleUserLeave)
      // 用户拒绝通话
      this.$tuiCallEngine.on(this.TUICallEvent.REJECT, this.handleInviteeReject)
      // 对方忙线
      this.$tuiCallEngine.on(
        this.TUICallEvent.LINE_BUSY,
        this.handleInviteeLineBusy,
      )
      // 接受的邀请被取消。
      this.$tuiCallEngine.on(
        this.TUICallEvent.CALLING_CANCEL,
        this.handleInviterCancel,
      )
      // 重复登陆，收到该回调说明被踢出房间
      this.$tuiCallEngine.on(this.TUICallEvent.KICKED_OUT, this.handleKickedOut)
      // 作为被邀请方会收到，收到该回调说明本次通话超时未应答
      this.$tuiCallEngine.on(
        this.TUICallEvent.CALLING_TIMEOUT,
        this.handleCallTimeout,
      )
      // 邀请用户无应答
      this.$tuiCallEngine.on(this.TUICallEvent.NO_RESP, this.handleNoResponse)
      // 收到该回调说明本次通话结束了
      this.$tuiCallEngine.on(this.TUICallEvent.CALLING_END, this.handleCallEnd)
      // 远端用户开启/关闭了摄像头, 会收到该回调
      this.$tuiCallEngine.on(
        this.TUICallEvent.USER_VIDEO_AVAILABLE,
        this.handleUserVideoChange,
      )
      this.$tuiCallEngine.on(
        this.TUICallEvent.USER_AUDIO_AVAILABLE,
        this.handleUserAudioChange,
      )
      this.$tuiCallEngine.on(
        this.TUICallEvent.CALL_TYPE_CHANGED,
        this.handleCallTypeChange,
      )
      this.$tuiCallEngine.on(
        this.TUICallEvent.DEVICED_UPDATED,
        this.handleDeviceUpdated,
      )
    },
    removeListener() {
      this.$tuiCallEngine.off(this.TUICallEvent.ERROR, this.handleError)
      this.$tuiCallEngine.off(
        this.TUICallEvent.INVITED,
        this.handleNewInvitationReceived,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.USER_ACCEPT,
        this.handleUserAccept,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.USER_ENTER,
        this.handleUserEnter,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.USER_LEAVE,
        this.handleUserLeave,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.REJECT,
        this.handleInviteeReject,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.LINE_BUSY,
        this.handleInviteeLineBusy,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.CALLING_CANCEL,
        this.handleInviterCancel,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.KICKED_OUT,
        this.handleKickedOut,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.CALLING_TIMEOUT,
        this.handleCallTimeout,
      )
      this.$tuiCallEngine.off(this.TUICallEvent.NO_RESP, this.handleNoResponse)
      this.$tuiCallEngine.off(this.TUICallEvent.CALLING_END, this.handleCallEnd)
      this.$tuiCallEngine.off(
        this.TUICallEvent.USER_VIDEO_AVAILABLE,
        this.handleUserVideoChange,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.USER_AUDIO_AVAILABLE,
        this.handleUserAudioChange,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.CALL_TYPE_CHANGED,
        this.handleCallTypeChange,
      )
      this.$tuiCallEngine.off(
        this.TUICallEvent.DEVICED_UPDATED,
        this.handleDeviceUpdated,
      )
    },
    handleError(e) {
      console.log(`trtccalling-error: SDK内部错误-${e}`, e)
      this.dissolveMeetingIfNeed()
    },
    async handleNewInvitationReceived(payload) {
      const { inviteID, sponsor, inviteData } = payload
      log(`handleNewInvitationReceived ${JSON.stringify(payload)}`)
      if (inviteData.callEnd) {
        // 最后一个人发送 invite 进行挂断
        this.$store.commit('updateCallStatus', 'idle')
        return
      }
      // 这里需要考虑忙线的情况
      if (this.callStatus === 'calling' || this.callStatus === 'connected') {
        await this.$tuiCallEngine.reject({ inviteID, isBusy: true })
        return
      }
      const { callType } = inviteData
      this.$store.commit('updateIsInviter', false)
      this.$store.commit('updateCallStatus', 'calling')
      const response = await this.$tim.getUserProfile({ userIDList: [sponsor] })
      this.inviterName = response.data[0].nick || sponsor
      this.callTypeDisplayName =
        callType === this.TUICallType.AUDIO_CALL ? '语音通话' : '视频通话'
      this.$store.commit('updateCallType', callType)
    },
    getNewInvitationDialogContent() {
      return `来自${this.inviterName}的${this.callTypeDisplayName}`
    },
    // 拒绝
    handleRejectCall: async function () {
      try {
        const { callType } = this.inviteData
        await this.$tuiCallEngine.reject({
          inviteID: this.inviteID,
          isBusy: false,
          callType,
        })
        this.dissolveMeetingIfNeed()
      } catch (e) {
        this.dissolveMeetingIfNeed()
      }
    },

    handleDebounce(func, wait) {
      let context = this
      let args = arguments
      if (timeout) clearTimeout(timeout)
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    },

    // 有用户接听
    handleUserAccept({ userID }) {
      this.$store.commit('userAccepted', true)
      console.log(userID, 'accepted')
    },
    // 用户同意进入
    handleUserEnter({ userID }) {
      // 建立连接
      this.$store.commit('userJoinMeeting', userID)
      if (this.callStatus === 'calling') {
        // 如果是邀请者, 则建立连接
        this.$nextTick(() => {
          // 需要先等远程用户 id 的节点渲染到 dom 上
          this.$store.commit('updateCallStatus', 'connected')
        })
      } else {
        // 第n (n >= 3)个人被邀请入会, 并且他不是第 n 个人的邀请人
        this.$nextTick(() => {
          // 需要先等远程用户 id 的节点渲染到 dom 上
          this.$tuiCallEngine.startRemoteView({
            userID: userID,
            videoViewDomID: `video-${userID}`,
          })
        })
      }
    },
    // 离开
    handleUserLeave({ userID }) {
      console.log('用户离开', userID)
      this.$message.warning('通话已结束')
      this.dissolveMeetingIfNeed()
    },
    // 拒绝
    async handleInviteeReject({ userID }) {
      const response = await this.$tim.getUserProfile({ userIDList: [userID] })
      this.$message.warning(`${response.data[0].nick || userID}拒绝通话`)
      console.log('被邀用户拒绝邀请', userID)
      this.dissolveMeetingIfNeed()
    },
    // 忙线
    async handleInviteeLineBusy({ sponsor, userID }) {
      if (sponsor !== window.sessionStorage.getItem('userId')) {
        return
      }
      const response = await this.$tim.getUserProfile({ userIDList: [userID] })
      this.$message.warning(`${response.data[0].nick || userID}忙线`)
      this.dissolveMeetingIfNeed()
    },
    // 取消
    handleInviterCancel() {
      // 邀请被取消
      this.$message.warning('通话已取消')
      this.dissolveMeetingIfNeed()
    },
    // 重复登录被提出
    handleKickedOut() {
      //重复登陆，被踢出房间
      this.$tuiCallEngine.logout()
      this.$store.commit('userAccepted', false)
      this.$store.commit('updateTimLogin', false)
    },
    // 作为被邀请方会收到，收到该回调说明本次通话超时未应答
    handleCallTimeout() {
      this.$message.warning('通话超时未应答')
      console.log('通话超时未应答')
      this.dissolveMeetingIfNeed()
    },
    handleCallEnd() {
      this.$message.success('通话已结束')
      this.$tuiCallEngine.hangup()
      this.dissolveMeetingIfNeed()
      this.$store.commit('userAccepted', false)
    },
    async handleNoResponse({ userIDList }) {
      this.hiddenCallEndMessage = true
      const response = await this.$tim.getUserProfile({
        userIDList: [userIDList[0]],
      })
      this.$message.warning(`${response.data[0].nick || userIDList[0]}无应答`)
      this.dissolveMeetingIfNeed()
    },
    handleUserVideoChange: function ({ userID, isVideoAvailable }) {
      log(
        `handleUserVideoChange userID, ${userID} isVideoAvailable ${isVideoAvailable}`,
      )
    },
    handleUserAudioChange: function ({ userID, isAudioAvailable }) {
      log(
        `handleUserAudioChange userID, ${userID} isAudioAvailable ${isAudioAvailable}`,
      )
    },
    dissolveMeetingIfNeed() {
      this.$store.commit('updateCallStatus', 'idle')
    },
    handleCallTypeChange({ newCallType }) {
      this.$store.commit('updateCallType', newCallType)
    },
    handleDeviceUpdated({
      microphoneList,
      cameraList,
      currentMicrophone,
      currentCamera,
    }) {
      const updateDevices = {
        micList: microphoneList,
        cameraList,
        currentMicrophone,
        currentCamera,
      }
      console.log(updateDevices, 'deviceList')
      this.$store.commit('updateDeviceList', updateDevices)
    },
    handleDebounce(func, wait) {
      let context = this
      let args = arguments
      if (timeout) clearTimeout(timeout)
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    },
  },
}
